import { CONTACT_RELATIONSHIPS } from '@nesso/client-contracts/client.commands';

export type ContactRelationship = (typeof CONTACT_RELATIONSHIPS)[number];

export const CONTACT_RELATIONSHIP_LABELS: Record<ContactRelationship, string> = {
    FAMILY_MEMBER: 'Family member',
    FRIEND: 'Friend',
    LEGAL_GUARDIAN: 'Legal guardian',
    PARENT: 'Parent',
    SPOUSE_PARTNER: 'Spouse/Partner',
    PHYSICIAN: 'Physician',
    OTHER: 'Other',
};

export const CONTACT_RELATIONSHIP_OPTIONS = CONTACT_RELATIONSHIPS.map((value) => ({
    value,
    label: CONTACT_RELATIONSHIP_LABELS[value],
}));
